const encoder = new TextEncoder();

function wr(msg) {
  console.log(msg);
}

async function readLoop(reader) {
  let buffer = '';
  const decoder = new TextDecoder();

  while (true) {
    const { value, done } = await reader.read();
    if (value) {
      const vvv = decoder.decode(value).split('\r\n');
      let trailing = vvv.pop();
      if (vvv.length > 0) {
        // There was newline in read buffer, so output
        wr(buffer + vvv.join('\r\n'));
        buffer = trailing;
      } else {
        buffer += trailing;
      }
    }
    if (done) {
      wr(`Read buffer from reader closing: ${buffer}`);
      reader.releaseLock();
      break;
    }
  }
}

export async function disconnect(port, writer, reader) {
  if (port !== null) {
    await writer.close();
    await reader.cancel();
    await port.close();
    writer = null;
    reader = null;
    port = null;
  }
}

export async function connect(port, writer, reader) {
  await disconnect(port, writer, reader);

  port = await navigator.serial.requestPort();
  await port.open({
    baudRate: 115200,
    dateBits: 8,
    stopBits: 1,
  });

  writer = port.writable.getWriter();
  reader = port.readable.getReader();

  readLoop(reader);
  return [port, writer, reader];
}

export async function sendScript(script, writer) {
  // Enter raw CTRL+A
  await writer.write(Uint8Array.from([0x01]));
  const ec = encoder.encode(script);
  await writer.write(ec);

  // Confirm CTRL-D
  await writer.write(Uint8Array.from([0x04]));
  // Exit raw CTRL-B
  await writer.write(Uint8Array.from([0x02]));
}

export async function sendPaste(script, writer) {
  // Enter paste mode - CTRL+E
  await writer.write(Uint8Array.from([0x05]));
  const ec = encoder.encode(script);
  await writer.write(ec);

  // Confirm CTRL-D to finish
  await writer.write(Uint8Array.from([0x04]));
}

export function checkWebSerialSupport() {
  if ('serial' in navigator) {
    return true;
  }
  return false;
}
